import {cloneDeep, get} from "lodash";
import {getString} from 'Core/helpers/data';
import {CampaignListItemDataObject} from "../dataObjects";
import {getDate, STANDARD_DATE_TIME_FORMAT} from "Core/helpers/datetime";
import {CAMPAIGN_TYPE} from 'Pages/apps/default/projectPages/campaign/const';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {CampaignListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new CampaignListItemDataObject(
		getString(result, 'type', CAMPAIGN_TYPE.REGULAR, true),
		getString(result, 'id'),
		getString(result, 'name'),
		getString(result, 'description'),
		getString(result, 'campaignStatus'),
		getDate(get(result, 'startDate', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
		getDate(get(result, 'endDate', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
	);

	return result;
}

// @note There is no output function since list is read only.